const baseStyleList = () => {
  return {
    borderWidth: '1px',
    borderColor: 'light.border',
    boxShadow: 'light.primary',
    padding: '8px',
    borderRadius: '10px',
  };
};

const baseStyleItem = () => {
  return {
    borderRadius: '6px',
    fontSize: '14px',
    _focus: { bg: '#F6F7F7', fontWeight: 700 },
    _hover: { bg: '#F6F7F7', fontWeight: 700 },
  };
};

const baseStyle = () => ({
  list: baseStyleList(),
  item: baseStyleItem(),
});

export const Menu = {
  baseStyle,
};
